export default {
  '1': '#7eb764',
  '2': '#a98577',
  '3': '#ef6c4b',
}
